import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { Divider } from "@material-ui/core";
import { InputLabel, TextField } from "@material-ui/core";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useHistory, useParams } from "react-router-dom";

import * as Yup from "yup";
import Select from "../../formUI/Select";
import { useDispatch } from "react-redux";
import axios from "axios";
import { openToastAndSetContent } from "../../../redux/actions/toast/toastActions";
import {
	openLoader,
	closeLoader,
} from "../../../redux/actions/loader/loaderActions";
import { closeModal } from "../../../redux/actions/modal/modalActions";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
	root: {
		"& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			border: "none",
		},
		"& .MuiOutlinedInput-input.MuiInputBase-input.MuiInputBase-input.MuiOutlinedInput-input":
		{
			textAlign: "center",
			padding: "8.1px 14px",
		},
	},
	select: {
		"& .MuiOutlinedInput-root": {
			color: "#414141",
			fontFamily: "Avenir",
			fontStyle: "normal",
			fontWeight: "normal",
			fontSize: "14px",
			lineHeight: "16px",
		},
		"&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
			outline: "none",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
			backgroundColor: "#ffffff",
		},
		"& .MuiInputLabel-root.Mui-focused": {
			color: "#E0E0E0",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			border: "1px solid #E0E0E0",
		},
	},
});

const AddPaymentProperty = ({
	content,
	identifier,
	id,
	fetchBusinesses,
}: {
	content?: any;
	identifier: string;
	id: any;
	fetchBusinesses: any;
}) => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const validate = Yup.object({
		provider: Yup.string().required("Required"),
		currency: Yup.string().required("Required"),
		password: Yup.string().required("Required"),
		secretkey: Yup.string().required("Required"),
		mid: Yup.string().required("Required"),
	});

	const [providers, SetProviders] = useState<any>();
	const [details, setDetails] = useState<any>();

	const fetchProviders = async () => {
		dispatch(openLoader());
		try {
			const data: any = await axios.get(`/v1/utility/providers`);
			SetProviders(data?.data);
			dispatch(closeLoader());
		} catch (err: any) {
			dispatch(closeLoader());
			dispatch(
				dispatch(
					openToastAndSetContent({
						toastContent:
							err.response?.data?.message ||
							err?.data?.message ||
							err?.message ||
							err,
						toastType: "error",
					})
				)
			);
		}
	};

	const paymentMethodOption = [
		{
			name: "card",
		},
		{
			name: "qr",
		},
		{
			name: "ussd",
		},
		{
			name: "bank",
		},
		{
			name: "transfer",
		},
	];

	const transactionLocaleOption = [
		{
			name: "NGN",
		},
		{
			name: "USD",
		},
	];

	useEffect(() => {
		fetchProviders();
	}, []);

	useEffect(() => {
		axios.get<any>(`/v1/business/${id}`).then((res) => {
			setDetails(res.data);
		});
	}, [id]);

	let providerOptions = providers?.providers?.map(function (bank: any) {
		return {
			value: bank.id,
			name: bank.providershortname,
		};
	});

	const INITIAL_VALUES = {
		propertyid: content ? content?.id : null,
		password: content ? content?.password : "",
		provider: content ? content?.provider : "",
		secretkey: content ? content?.secretKey : "",
		currency: content ? content?.currency : "",
		value1: "",
		value2: "",
		value3: "",
		value4: "",
		value5: "",
		mid: content ? content?.mid : "",
	};

	return (
		<div className={styles.generalFourReuse}>
			<h3 className={styles.generalh3}>{identifier} Payment Property</h3>
			<Divider />

			<div className={styles.selectinput}>
				<Formik
					initialValues={INITIAL_VALUES}
					validationSchema={validate}
					onSubmit={(values) => {
						dispatch(openLoader());
						const newObject =
							identifier === "Edit"
								? {
									...values,
									propertyid: content?.id,
								}
								: {
									...values,
								};

						const payload = { ...newObject, mcc: details?.business?.mcc };
						axios
							.post(`/v1/business/${id}/payment/property/add`, payload)
							.then((res: any) => {
								fetchBusinesses();
								dispatch(closeLoader());
								dispatch(
									openToastAndSetContent({
										toastContent: res?.data?.message,
										toastType: "success",
									})
								);
								dispatch(closeModal());
							})
							.catch((err) => {
								dispatch(closeLoader());
								dispatch(
									openToastAndSetContent({
										toastContent: err?.response?.data?.message || err?.message,
										toastType: "error",
									})
								);
							});
					}}
				>
					{(props) => (
						<Form>
							<div
								style={{
									display: "flex",
									flexDirection: "row",
									alignItems: "baseline",
									justifyContent: "space-between",
								}}
							>
								<div
									style={{
										width: "50%",
									}}
								>
									<InputLabel>
										<span className={styles.span}>Provider</span>
									</InputLabel>
									<Field
										as={Select}
										helperText={
											<ErrorMessage name="provider">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="provider"
										size="small"
										options={providerOptions}
										defaultValue={providerOptions && providerOptions[0]}
										className={classes.select}
										// fullWidth
										style={{
											marginTop: "8px",
											marginBottom: "18px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Currency</span>
									</InputLabel>
									<Field
										as={Select}
										helperText={
											<ErrorMessage name="currency">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="currency"
										size="small"
										options={transactionLocaleOption}
										className={classes.select}
										defaultValue={
											transactionLocaleOption && transactionLocaleOption[0]
										}
										// fullWidth
										style={{
											marginTop: "8px",
											marginBottom: "18px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Password</span>
									</InputLabel>
									<Field
										as={TextField}
										helperText={
											<ErrorMessage name="password">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="password"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "18px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Secret Key</span>
									</InputLabel>
									<Field
										as={TextField}
										helperText={
											<ErrorMessage name="secretkey">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="secretkey"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "18px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Value One</span>
									</InputLabel>
									<Field
										as={TextField}
										// helperText={
										//   <ErrorMessage name="value1">
										//     {(msg) => <span style={{ color: "red" }}>{msg}</span>}
										//   </ErrorMessage>
										// }
										name="value1"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>
									<InputLabel>
										<span className={styles.span}>MID</span>
									</InputLabel>
									<Field
										as={TextField}
										helperText={
											<ErrorMessage name="mid">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										name="mid"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>
								</div>

								<div
									style={{
										width: "50%",
										marginLeft: "20px",
									}}
								>
									<InputLabel>
										<span className={styles.span}>Value two</span>
									</InputLabel>
									<Field
										as={TextField}
										// helperText={
										//   <ErrorMessage name="value2">
										//     {(msg) => <span style={{ color: "red" }}>{msg}</span>}
										//   </ErrorMessage>
										// }
										name="value2"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>
									<InputLabel>
										<span className={styles.span}>Value three</span>
									</InputLabel>
									<Field
										as={TextField}
										// helperText={
										//   <ErrorMessage name="value3">
										//     {(msg) => <span style={{ color: "red" }}>{msg}</span>}
										//   </ErrorMessage>
										// }
										name="value3"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>Value four</span>
									</InputLabel>
									<Field
										as={TextField}
										// helperText={
										//   <ErrorMessage name="value4">
										//     {(msg) => <span style={{ color: "red" }}>{msg}</span>}
										//   </ErrorMessage>
										// }
										name="value4"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>
									<InputLabel>
										<span className={styles.span}>Value five</span>
									</InputLabel>
									<Field
										as={TextField}
										// helperText={
										//   <ErrorMessage name="value5">
										//     {(msg) => <span style={{ color: "red" }}>{msg}</span>}
										//   </ErrorMessage>
										// }
										name="value5"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
											marginBottom: "22px",
										}}
									/>

									<InputLabel>
										<span className={styles.span}>OTP</span>
									</InputLabel>
									<Field
										as={TextField}
										helperText={
											<ErrorMessage name="otp">
												{(msg) => <span style={{ color: "red" }}>{msg}</span>}
											</ErrorMessage>
										}
										InputLabelProps={{
											style: { fontSize: "0.8em" },
										}}
										label="Get OTP from Google Authenticator App"
										name="otp"
										variant="outlined"
										margin="normal"
										type="text"
										size="small"
										fullWidth
										className={classes.select}
										style={{
											marginTop: "8px",
										}}
									/>
									<InputLabel>
										<div
											style={{
												display: "flex",
												alignItems: "center",
											}}
										>
											<InfoRoundedIcon />
											<p className={styles.info}>
												If you have not set up your 2FA, kindly{" "}
												<a
													style={{ color: "blue" }}
													href={`/account`}
													target="_blank"
												>
													click here
												</a>
											</p>
										</div>
									</InputLabel>
								</div>
							</div>

							<button
								style={{
									backgroundColor: "#27AE60",
									fontFamily: "Avenir",
									fontStyle: "normal",
									fontWeight: "bold",
									fontSize: "16px",
									lineHeight: "19px",
									textAlign: "center",
									border: "none",
									outline: "none",
									width: "100%",
									color: "#FFFFFF",
									padding: "13.39px 0",
									marginTop: "30px",
									cursor: "pointer",
									borderRadius: "20px",
								}}
								type="submit"
							>
								Submit
							</button>
						</Form>
					)}
				</Formik>
			</div>
		</div>
	);
};

export default AddPaymentProperty;
